import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadSeasonalityData } from "reducers/etc";
import { Bar } from "react-chartjs-2";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { CircularProgress } from "@mui/material";
import SoftTypography from "components/SoftTypography";

const SeasonalityButtons = ({ onSelectGraph }) => {
  const [selectedGraph, setSelectedGraph] = useState("S&P 500");
  const [exchange, setExchange] = useState("");
  const handleClick = (graph) => {
    setSelectedGraph(graph);
    onSelectGraph(graph);
  };

  return (
    <div className="SeasonalityButtons" style={{ marginBottom: "16px" }}>
      <SoftButton
        variant="contained"
        color={selectedGraph === "S&P 500" ? "success" : "secondary"}
        onClick={() => handleClick("S&P 500")}
      >
        S&P 500
      </SoftButton>
      <SoftButton
        onClick={() => handleClick("Dow Jones")}
        color={selectedGraph === "Dow Jones" ? "success" : "secondary"}
      >
        Dow Jones
      </SoftButton>
      <SoftButton onClick={() => handleClick("Nasdaq")} color={selectedGraph === "Nasdaq" ? "success" : "secondary"}>
        Nasdaq
      </SoftButton>

      <SoftButton
        onClick={() => handleClick("Oil (WTI)")}
        color={selectedGraph === "Oil (WTI)" ? "success" : "secondary"}
      >
        Oil (WTI)
      </SoftButton>
      {/* Add more buttons for other graphs */}
    </div>
  );
};

const SeasonalityGraph = ({ graphdata, options, label }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Example data for demonstration
        const data = {
          labels: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ],
          datasets: [
            {
              label: "2025",
              data: graphdata[2025], // Replace with your actual data
              backgroundColor: "rgb(27, 63, 95)",

              // borderRadius:0,
              // borderColor:'black',

              // borderWidth: 2,
              barThickness: 20,
            },
            {
              label: "2024",
              data: graphdata[2024], // Replace with your actual data
              backgroundColor: "#8c141b",

              // borderRadius:0,
              borderColor:'white',
              borderWidth: 2,
              barThickness: 20,
            },
            {
              label: "2023",
              data: graphdata[2023], // Replace with your actual data
              backgroundColor: "#00662a",

              // borderRadius:0,
              borderColor:'white',
              borderWidth: 0,
              barThickness: 20,
            }
            // Add similar datasets for NASDAQ, Russell 2000, and WTI oil
          ],
        };

        setChartData(data);
        setLoading(false);
      } catch (error) {
        setError("Error fetching data");
        setLoading(false);
        console.error("Error fetching data:", error.message);
      }
    };

    fetchData();
  }, []);

  if (!graphdata)
    return (
      <SoftBox>
        <SoftTypography variant="body2">Sorry! {label} data is unavailable. Please try again later.</SoftTypography>
      </SoftBox>
    );

  if (loading) {
    return <div>Loading data...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div>
      <h2>Monthly Seasonality Chart (%)</h2>
      <Bar data={chartData} options={graphdata["options"]} />
    </div>
  );
};

export default () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const seasonalityData = useSelector((state) => state.etc.seasonalityData);
  const [selectedGraph, setSelectedGraph] = useState("S&P 500");

  useEffect(() => {
    dispatch(loadSeasonalityData()).then(() => setIsLoading(false));
  }, []);

  const handleSelectGraph = (graph) => {
    setSelectedGraph(graph);
  };

  const optionsWithAdjustedYAxis = {
    scales: {
      y: {
        suggestedMin: -5,
        suggestedMax: 5,
        title: {
          display: true,
          text: "Average Monthly Return %",
        },
      },
    },
  };

  return (
    <SoftBox p={2}>
      <SeasonalityButtons onSelectGraph={handleSelectGraph} />
      {isLoading ? (
        <SoftBox style={{ textAlign: "center" }}>
          <CircularProgress />
        </SoftBox>
      ) : seasonalityData ? (
        <div>
          {selectedGraph === "S&P 500" && (
            <SeasonalityGraph label="S&P 500" graphdata={seasonalityData["SPX"]} options={optionsWithAdjustedYAxis} />
          )}
          {selectedGraph === "Dow Jones" && (
            <SeasonalityGraph label="Dow Jones" graphdata={seasonalityData["DJI"]} options={optionsWithAdjustedYAxis} />
          )}
          {selectedGraph === "Nasdaq" && (
            <SeasonalityGraph label="Nasdaq" graphdata={seasonalityData["NDAQ"]} options={optionsWithAdjustedYAxis} />
          )}
          {selectedGraph === "Oil (WTI)" && (
            <SeasonalityGraph label="Oil (WTI)" graphdata={seasonalityData["WTI"]} options={optionsWithAdjustedYAxis} />
          )}
        </div>
      ) : (
        <></>
      )}
    </SoftBox>
  );
};
